import React from 'react';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Layout from '../components/Layout';
import Logo from '../components/Logo';
import Socials from '../components/SocialsStatic';

const Wrapper = styled.div`
  min-width: 320px;
  height: 100vh;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url('${props => props.image}');

  @media screen and (max-width: 550px){
    background-position: 54% 50%;
  }
`;

const InnerWrapper = styled.div`
  padding: 1rem 1.8rem;
  @media screen and (max-width: 500px) {
    padding: 1rem 0.5rem;
  }
`;

const HeroText = styled.h2`
  font-family: ${props => props.theme.font.bodyThinFontFamily};
  color: ${props => props.theme.colors.lightGrey};
  font-size: 2.5rem;
  letter-spacing: 2px;
  line-height: 1.5;
  margin-top: 5rem;
  text-transform: uppercase;
  @media screen and (max-height: 800px) {
    font-size: 2rem;
  }
  @media screen and (max-width: 450px) {
    font-size: 1.9rem;
  }
  @media screen and (max-width: 361px) {
    font-size: 1.5rem;
  }
  @media screen and (max-height: 400px) {
    font-size: 1.4rem;
  }
`;

const Index = ({ data }) => (
  <Layout nologo>
    <Logo light onlyLogo />
    <Wrapper image={data.hero.childImageSharp.original.src}>
      <InnerWrapper>
        <HeroText>
          HANDCRAFTED. <br /> luxury.
          <br /> TRUNKS.
        </HeroText>
      </InnerWrapper>
      <Socials centerItems />
    </Wrapper>
  </Layout>
);

Index.propTypes = {
  data: PropTypes.shape({
    hero: PropTypes.shape({
      childImageSharp: PropTypes.shape({
        resize: PropTypes.shape({
          src: PropTypes.string,
        }),
      }),
    }),
  }).isRequired,
};

export default Index;

export const query = graphql`
  query {
    hero: file(relativePath: { eq: "Home.jpg" }) {
      childImageSharp {
        original {
          src
        }
      }
    }
  }
`;
